<template>
	<router-view />
</template>

<script>
	export default {
		name: "App",
		components: {},
	};
</script>

<style>
	@import url("/src/assets/css/style.less");

	.clime-line-1 {
		overflow: hidden;
		/*超出部分隐藏*/
		text-overflow: ellipsis;
		/* 超出部分显示省略号 */
		white-space: nowrap;
		/*规定段落中的文本不进行换行 */
	}

	.clime-line-2 {
		display: -webkit-box;
		overflow: hidden;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
</style>